import { createUUID, getColorFromLocalStorage } from "../../utils/utils";
import { DialogGeneral } from "../../utils/Dialog/dialog";
import '../../styles/Dialog/formLabelPoint.css';
import { getMessage } from "../../language";

// Interface định nghĩa cấu trúc dữ liệu cho form
export interface InputForm {
    name: string | undefined;
    url: string | undefined;
    fontSize: number | 14;
    hexColor: string | undefined;
    isFolder?: boolean | false;
    displayName?: string | undefined;
}

// Lớp quản lý form Label Point
export class FormLabelPoint {
    viewer: any;
    containerId: string;
    modal: any;
    inputForm: InputForm = {
        displayName: "",
        name: "",
        fontSize: 14,
        url: "",
        hexColor: getColorFromLocalStorage(),
    };
    forFoler: boolean = false;
    isEditFolder: boolean = false;
    isEditPointFolder: boolean = false;
    isEditLabel: boolean = false; // Biến để xác định trạng thái chỉnh sửa label
    private dialog: DialogGeneral | undefined;
    private _checkPicker: boolean = true;
    private _checkIsFolder: boolean = false;
    private onClosedCallback: ((status: boolean, label?: InputForm) => void) | undefined; // Callback khi đóng modal
    private containerBody: HTMLDivElement | undefined;
    private containerFooter: HTMLDivElement | undefined;
    private fontSizeInput: HTMLInputElement | null = null;
    private _inputUrl: HTMLInputElement | undefined;
    private _inputFontSize: HTMLInputElement | undefined;
    private _inputCheckPicker: HTMLInputElement | undefined;
    private _inputCheckFolder: HTMLInputElement | undefined;

    IdGenneral = createUUID(); // Tạo ID ngẫu nhiên khi khởi tạo

    constructor(containerId: string, viewer: any) {
        this.containerId = containerId; // Gán giá trị containerId
        this.viewer = viewer; // Gán giá trị viewer
    }

    //#region setClosedCallback
    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean, label?: InputForm) => void): void {
        this.onClosedCallback = callback;
    }
    //#endregion

    //#region notifyCallBack
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean, label?: InputForm): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status, label); // Thông báo cho lớp cha
        } else {
            console.error("State change callback is not set.");
        }
        // Reset trạng thái
        this.forFoler = false;
        this.isEditFolder = false;
        this._checkPicker = true;
        this._checkIsFolder = false;
        this.isEditPointFolder = false;
        this.isEditLabel = false;

    }
    //#endregion

    //#region createModalLabelPoint
    // Tạo modal
    createModalLabelPoint = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage("label-properties-dialog-header");
        this.dialog.isModal = true;
        this.dialog.minimizeDialog = false;
        this.dialog.zIndex = 1000;
        this.dialog.topModal = "50%";
        this.dialog.leftModal = "50%";
        this.dialog.widthModal = '250px';
        this.dialog.minHeightModal = 310;
        this.dialog.minWidthModal = 200;
        this.dialog.firstLoad = false;

        // Gán nội dung cho modal
        this.dialog.innerBody = this.renderBodyModal();
        this.dialog.innerFooter = this.renderFooter();
        this.dialog.createDialog();

        this._changeTittle()
    };
    //#endregion

    //#region showHideModalLabelPoint
    // Hiển thị hoặc ẩn modal
    showHideModalLabelPoint = (show: boolean) => {
        this.dialog?.showModal(show);
    };
    //#endregion

    //#region handleCloseModal
    // Xử lý khi đóng modal
    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status, undefined);
            this.inputForm = {
                displayName: "",
                name: "",
                fontSize: 14,
                url: "",
                hexColor: getColorFromLocalStorage()
            };
        }
    };
    //#endregion

    //#region renderBodyModal
    // Tạo nội dung body của modal
    private renderBodyModal = (): HTMLElement => {
        if (this.containerBody) {
            this.clearContainer();
        } else {
            this.containerBody = document.createElement('div');
            this.containerBody.className = 'container-form-label-point';
        }

        this.createForm();
        return this.containerBody;
    };
    //#endregion

    //#region clearContainer
    // Xóa nội dung trong container
    private clearContainer = () => {
        if (this.containerBody) {
            while (this.containerBody.firstChild) {
                this.containerBody.removeChild(this.containerBody.firstChild);
            }
        }
    };
    //#endregion
    private _changeTittle = () => {
        const headerName = document.getElementById(`modal-header-${this.dialog?.IdGenneral}`) as HTMLDivElement;
        if (headerName) {
            const firstChild = headerName.querySelector('div:first-child') as HTMLDivElement;
            if (firstChild) {
                if (this.forFoler) {
                    firstChild.innerHTML = getMessage("label-properties-dialog-header-create-folder");
                } else if (this.isEditFolder) {
                    firstChild.innerHTML = getMessage("label-properties-dialog-header-edit-folder");
                } else if (this.isEditPointFolder) {
                    firstChild.innerHTML = getMessage("label-properties-dialog-header-edit-root-label");
                } else if (this.isEditLabel) {
                    firstChild.innerHTML = getMessage("label-properties-dialog-header-edit-label");
                } else {
                    firstChild.innerHTML = getMessage("label-properties-dialog-header");
                }
            }
        }
    }

    //#region createForm
    // Tạo form trong modal
    private createForm = () => {
        // Nội dung form tùy thuộc vào trạng thái
        if (this.forFoler) {
            this.containerBody!.innerHTML = `
            
                <label>${getMessage("label-properties-enter-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-name-${this.IdGenneral}" type="text" value="${this.inputForm.name}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>        
                 <label>${getMessage("label-properties-enter-display-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-display-name-${this.IdGenneral}" type="text" value="${this.inputForm.displayName}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>       
                <label>${getMessage("label-properties-color-point")}:</label>
                <input class="input-form-label dpu-inpu-color" id="label-color-${this.IdGenneral}" value="${this.inputForm.hexColor}" type="color"/>
            `;
        } else if (this.isEditFolder) {
            this.containerBody!.innerHTML = `
          
                <label>${getMessage("label-properties-enter-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-name-${this.IdGenneral}" type="text" value="${this.inputForm.name}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
                  <label>${getMessage("label-properties-enter-display-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-display-name-${this.IdGenneral}" type="text" value="${this.inputForm.displayName}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
                <div class="checkbox-container" style="margin:3px 0">
                    <input type="checkbox" class="dpu-input-check-box" id="check-picker-label-${this.IdGenneral}" ${this._checkPicker ? "checked" : ""}/>
                    <label for="check-picker-label-${this.IdGenneral}">${getMessage("label-properties-check-folder")}</label>
                </div>
                <label>${getMessage("label-properties-enter-url")}:</label>
                <input class="input-form-label dpu-input-text disable" id="label-url-${this.IdGenneral}" type="text" value="${this.inputForm.url}" placeholder="${getMessage("label-properties-enter-url-placeholder")}" disabled/>
                <label>${getMessage("label-properties-enter-size-point")}:</label>
                <input class="input-form-label dpu-input-text disable" id="label-fontsize-${this.IdGenneral}" type="number" value="${this.inputForm.fontSize}" disabled/>
                <label>${getMessage("label-properties-color-point")}:</label>
                <input class="input-form-label dpu-inpu-color" id="label-color-${this.IdGenneral}" value="${this.inputForm.hexColor}" type="color"/>
            `;
        } else if (this.isEditPointFolder) {
            this.containerBody!.innerHTML = `
            
            <label>${getMessage("label-properties-enter-name")}:</label>
             <input class="input-form-label dpu-input-text"  id="label-name-${this.IdGenneral}" type="text" value = "${this.inputForm.name}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
<label>${getMessage("label-properties-enter-display-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-display-name-${this.IdGenneral}" type="text" value="${this.inputForm.displayName}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
            <div class="checkbox-container">
            <input 
                type="checkbox" 
                class="dpu-input-check-box" 
                id="check-folder-label-${this.IdGenneral}" 
                ${this._checkIsFolder ? "checked" : ""} 
                
            />
            <label for="check-folder-label-${this.IdGenneral}">${getMessage("label-properties-check-folder")}</label>
            </div>

            <label>${getMessage("label-properties-enter-url")}:</label>
             <input class="input-form-label dpu-input-text"  id="label-url-${this.IdGenneral}" type="text" value = "${this.inputForm.url}"  placeholder="${getMessage("label-properties-enter-url-placeholder")}"/>
            
             <label>${getMessage("label-properties-enter-size-point")}:</label>
             <input class="input-form-label dpu-input-text"   id="label-fontsize-${this.IdGenneral}" type="number" value = "${this.inputForm.fontSize}"/>
            <label>${getMessage("label-properties-color-point")}:</label>
             <input  class="input-form-label dpu-inpu-color"  id="label-color-${this.IdGenneral}" value = "${this.inputForm.hexColor}" type="color"/>
            `
        }

        else {
            this.containerBody!.innerHTML = `
           
                <label>${getMessage("label-properties-enter-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-name-${this.IdGenneral}" type="text" value="${this.inputForm.name}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
                 <label>${getMessage("label-properties-enter-display-name")}:</label>
                <input class="input-form-label dpu-input-text" id="label-display-name-${this.IdGenneral}" type="text" value="${this.inputForm.displayName}" placeholder="${getMessage("label-properties-enter-name-placeholder")}"/>
                <label>${getMessage("label-properties-enter-url")}:</label>
                <input class="input-form-label dpu-input-text" id="label-url-${this.IdGenneral}" type="text" value="${this.inputForm.url}" placeholder="${getMessage("label-properties-enter-url-placeholder")}"/>
                <label>${getMessage("label-properties-enter-size-point")}:</label>
                <input class="input-form-label dpu-input-text" id="label-fontsize-${this.IdGenneral}" type="number" value="${this.inputForm.fontSize}"/>
                <label>${getMessage("label-properties-color-point")}:</label>
                <input class="input-form-label dpu-inpu-color" id="label-color-${this.IdGenneral}" value="${this.inputForm.hexColor}" type="color"/>
            `;
        }

        this.handleTrackInput();
    };
    //#endregion

    //#region renderFooter
    // Tạo footer cho modal
    private renderFooter = (): HTMLElement => {
        this.containerFooter = document.createElement('div');
        this.containerFooter.className = 'container-footer-lable-point';
        this.containerFooter.innerHTML = `
            <button id="btn-create-${this.containerId}" class="btn-ok-modal">OK</button>
        `;

        // Gán sự kiện cho nút OK
        const btnOk = this.containerFooter.querySelector(`#btn-create-${this.containerId}`);
        if (btnOk) {
            btnOk.addEventListener('click', () => this.btnOk());
        }

        return this.containerFooter;
    };
    //#endregion

    //#region handleTrackInput
    // Theo dõi thay đổi của các input trong form
    private handleTrackInput = () => {
        this.fontSizeInput = this.containerBody!.querySelector(`#label-fontsize-${this.IdGenneral}`);
        const colorInput = this.containerBody!.querySelector(`#label-color-${this.IdGenneral}`);
        this._inputUrl = this.containerBody?.querySelector(`#label-url-${this.IdGenneral}`) as HTMLInputElement;
        this._inputFontSize = this.containerBody?.querySelector(`#label-fontsize-${this.IdGenneral}`) as HTMLInputElement;
        this._inputCheckPicker = this.containerBody?.querySelector(`#check-picker-label-${this.IdGenneral}`) as HTMLInputElement;
        this._inputCheckFolder = this.containerBody?.querySelector(`#check-folder-label-${this.IdGenneral}`) as HTMLInputElement;

        // Theo dõi thay đổi của checkbox "Thư mục"
        if (this._inputCheckPicker) {
            this._inputCheckPicker.addEventListener("change", (event) => {
                this._checkPicker = (event.target as HTMLInputElement).checked;
                this.toggleInputState(this._checkPicker);
            });
        }

        if (this._inputCheckFolder) {
            this._inputCheckFolder.addEventListener("change", (event) => {
                this._checkIsFolder = (event.target as HTMLInputElement).checked;
                this.toggleInputState(this._checkIsFolder);
            });
        }

        // Theo dõi thay đổi của input font size
        this.fontSizeInput?.addEventListener("input", this.validateAndHandleFontSizeChange);

        // Theo dõi thay đổi của input màu sắc
        colorInput?.addEventListener("input", this.handleColorChange);
    };
    //#endregion

    //#region toggleInputState
    // Bật/tắt trạng thái của các input
    private toggleInputState = (isDisabled: boolean) => {
        if (isDisabled) {
            this._inputUrl!.disabled = true;
            this._inputUrl?.classList.add('disable');
            this._inputFontSize!.disabled = true;
            this._inputFontSize?.classList.add('disable');
        } else {
            this._inputUrl!.disabled = false;
            this._inputUrl?.classList.remove('disable');
            this._inputFontSize!.disabled = false;
            this._inputFontSize?.classList.remove('disable');
        }
    };
    //#endregion

    //#region validateAndHandleFontSizeChange
    // Xử lý thay đổi giá trị font size
    private validateAndHandleFontSizeChange = () => {
        if (this.fontSizeInput) {
            let fontSize = parseInt(this.fontSizeInput.value, 10);
            if (isNaN(fontSize) || fontSize <= 0) {
                fontSize = 1; // Gán giá trị mặc định nếu không hợp lệ
            }
            this.fontSizeInput.value = String(fontSize);
        }
    };
    //#endregion

    //#region handleColorChange
    // Xử lý thay đổi giá trị màu sắc
    private handleColorChange = (event: Event): void => {
        const input = event.target as HTMLInputElement;
        const colorValue = input.value.trim();
        localStorage.setItem("selectedColor", colorValue); // Lưu mã màu xuống localStorage
    };
    //#endregion

    //#region btnOk
    // Xử lý khi nhấn nút OK
    private btnOk = () => {
        const labelName = (document.getElementById(`label-name-${this.IdGenneral}`) as HTMLInputElement)?.value.trim();
        const labelUrl = this._inputUrl?.value.trim() || undefined;
        const labelFontSize = this._inputFontSize?.value.trim() || undefined;
        const labelColor = (document.getElementById(`label-color-${this.IdGenneral}`) as HTMLInputElement)?.value.trim();
        const labelDisplayName = (document.getElementById(`label-display-name-${this.IdGenneral}`) as HTMLInputElement)?.value.trim();

        // Kiểm tra các trường có bị để trống không
        if (!this.forFoler && !this._checkIsFolder && (!labelName || !labelFontSize || !labelColor)) {
            alert(getMessage("label-point-name-must-not-be-empty"));
            return;
        }
        if ((this.forFoler && !labelName) || (this._checkIsFolder && !labelName)) {
            alert(getMessage("label-point-name-must-not-be-empty"));
            return;
        }

        // Kiểm tra tính hợp lệ của URL
        if (!this._checkIsFolder && labelUrl) {
            const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
            if (!urlPattern.test(labelUrl)) {
                alert("URL không hợp lệ!");
                return;
            }
        }

        // Tạo đối tượng label mới
        let newLabel: InputForm = {
            displayName: labelDisplayName,
            name: labelName,
            url: labelUrl || "",
            hexColor: labelColor,
            fontSize: Number(labelFontSize),
            isFolder: this.isEditFolder,
        };

        if (!this._checkPicker) {
            newLabel.isFolder = this._checkIsFolder;
        }

        if (this._checkIsFolder) {
            newLabel.url = ""
            newLabel.isFolder = true
        }


        // Gọi callback để thông báo
        this.notifyCallBack(true, newLabel);

        // Reset form
        this.inputForm = {
            displayName: "",
            name: "",
            fontSize: 14,
            url: "",
            hexColor: getColorFromLocalStorage(),
            isFolder: false,
        };

        // Đóng modal
        this.dialog?.destroyDialog();
    };
    //#endregion
}
